import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import AdminAPI from './AdminAPI'
import SystemActions from '../../actions/system/system-actions'
import UserActions from '../../actions/user/user-actions'
import UserFacingAPIReturnTypes from '../../common/UserFacingAPIReturnTypes'
import FoldoutCP from '../common/displaySchema/FoldoutCP'
import NewUserCP from './NewUserCP'


class AdminCP extends Component {
  constructor() {
    super()
    // this.state = {}
    this.newUserFormEle = createRef()
  }

  newUserOnSubmit (formVals) {
    console.log('AdminCP ', formVals)
    let newUser = {
      'name':formVals.playerName,
      'email':formVals.email,
    }

    AdminAPI.makeNewUser(newUser).then(result => {
      console.log(result)
      let isSuccess = (result?.data?.message?.type === UserFacingAPIReturnTypes['success'])
      this.props.handleUserFacingMessages(result)
      if (isSuccess) {
        this.resetForm()
        // TODO: this is HACKY!
        //  this logic belongs on the server side in the newUser hook
        //  In order to do that return messages from the server needs to be an array
        //  because the user could be made but the email could fail
        //  And I don't have the GAFs to do that right now
        this.props.requestPwReset(newUser.email)
      }
    }).catch(err => {
      this.props.handleUserFacingMessages(err)
    })
  }

  resetForm () {
    this.newUserFormEle.current.resetForm()
  }

  render() {
    if (this.props.user.auth === 0) {
      return (
        <div className="admin-page">
          Sorry, user {this.props.user.name} does not have admin permissions.
        </div>
      )
    }

    return (
      <div className="admin-page">
        <FoldoutCP displayName="New Player" isOpen={true} >
          <NewUserCP ref={this.newUserFormEle} onSubmit={(formVals) => {this.newUserOnSubmit(formVals)}} />
        </FoldoutCP>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  }
}
  
const mapDispatchToProps = (dispatch) => {
  return {
    handleUserFacingMessages: mess => dispatch(SystemActions.handleUserFacingMessages(mess)),
    requestPwReset: (email) => dispatch(UserActions.requestPwReset(email)),
  }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(AdminCP)
